import { useEffect } from 'react'
import {getListMasterKpis, getMasterKpiById} from '../../../services/sKPI/masterKpi.service'


const useGetMasterKpisMaintainer = (masterKpis, setMasterKpis) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getListMasterKpis();
                const response = serviceResponse.data;
                const aux_array = [];

                response.data.forEach(element => {
                    aux_array.push({
                        id: element.id ,
                        name: element.name,
                        descripcion: element.descripcion,
                        masterKpiCode: element.masterKpiCode,
                        masterKpiNemo: "",
                        typeOfId: element.typeOfId,
                        measurementUnitId: element.measurementUnitId,
                        objetiveId: element.objetiveId,
                        measurementPeriodId: element.measurementPeriodId,
                        timeAggregationId: element.timeAggregationId,
                        formulaId: element.formulaId,
                        statusId: element.statusId
                    })
                });

                setMasterKpis(aux_array);
            }
            catch (error) {
                setMasterKpis([]);
            }
        }
        
        if (masterKpis === null) {
            getData()
        }
    }, [masterKpis, setMasterKpis]);
}

const useGetMasterKpisMaintainer2 = (masterKpis, setMasterKpis, useIsPanelOpen, isPanelOpen) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getListMasterKpis();
                const response = serviceResponse.data;
                const aux_array = [];

                response.data.forEach(element => {
                    aux_array.push({
                        id: element.id ,
                        name: element.name,
                        descripcion: element.descripcion,
                        masterKpiCode: element.masterKpiCode,
                        masterKpiNemo: "",
                        typeOfId: element.typeOfId,
                        measurementUnitId: element.measurementUnitId,
                        objetiveId: element.objetiveId,
                        measurementPeriodId: element.measurementPeriodId,
                        timeAggregationId: element.timeAggregationId,
                        formulaId: element.formulaId,
                        statusId: element.statusId
                    })
                });

                setMasterKpis(prevState => ({
                    ...prevState,
                    fireUpdate: true,
                    data: aux_array
                }));
            }
            catch (error) {
            }
        }
        
        if (masterKpis.data === null && (useIsPanelOpen ? isPanelOpen : true )) {
            getData()
        }
    }, [masterKpis, setMasterKpis, useIsPanelOpen, isPanelOpen]);
}

const useGetMasterKpiById = (masterKpiId, masterKpi, setMasterKpi, isModalOpen) => {    
    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getMasterKpiById(masterKpiId);
                const response = serviceResponse.data;

                setMasterKpi(response.data);
            }
            catch (error) {
            }
        }
        
        if (masterKpiId !== null && masterKpi === null && isModalOpen === true) {
            getData()
        }
        else if (isModalOpen === false) {
                setMasterKpi(null);
        }
    }, [masterKpiId, masterKpi, setMasterKpi, isModalOpen]);
}


export {
    useGetMasterKpisMaintainer,
    useGetMasterKpisMaintainer2,
    useGetMasterKpiById
}